import React, { useState, useEffect } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever,
} from "@mui/icons-material";

import { 
  Gift,
  Potence,
} from "@dndModels";
import { 
  CHARACTER_LEVELS,
} from "@dndModels/Constants";
import { ModelBase } from "@models";

import DandDAPI from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectIndex from "@dndComponents/select/SelectObjectIndex";
import AddButton from "@components/input/buttons/AddButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import ModelBaseInput from "@dndComponents/ModelBaseInput";

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj: Potence;
  slot_level: number;
  onChange: (changed: Potence) => void;
  onDelete: () => void;
  disabled?: boolean;
  add_new_data?: any;
}

export default function AbilityPotenceSelfGiftsInput({ 
  obj,
  slot_level,
  onChange,
  onDelete,
  disabled = false,
  add_new_data
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [filter, setFilter] = useState<any>({ });
  const [use_selected, setUseSelected] = useState<boolean | undefined>(undefined);
  const [new_object, setNewObject] = useState<ModelBase | null>(null);
  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  
  const updateFilter = (changed: any = {}) => {
    const the_filter = {...changed};
    setUseSelected(the_filter.selected);
    delete the_filter.selected;
    setFilter(the_filter);
  }

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const submitNewObject = () => {
    // debugger;
    if (new_object && api.user && 
      (api.user.admin || 
        new_object._id === "" || 
        new_object.owner_id === api.user._id)) {
      setProcessing(true);
      if (!api.user.admin || new_object.source_books_old.filter(o => o.id === "Personal").length > 0) {
        new_object.owner_id = api.user._id;
      } else if (api.user.admin && new_object.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
        new_object.owner_id = "";
      }
      api.upsertObject("gift", new_object, true).then(res => {
        if (res && res.res instanceof ModelBase) {
          const newObject = res.res;
          obj.conditions_applied.push(newObject._id);
          onChange(obj);
        }
        setProcessing(false);
        setOpen(false);
        setReloading(true);
      });
    }
  }

  const renderExtras = () => {
    if (new_object) {
      return (
        <ModalOrDrawer
          open={open}
          onClose={() => { setOpen(false); }}
        >
          <ModelBaseInput
            obj={new_object}
            disabled={false}
            change_time={common_util.get_time_number()}
            no_back_button
            processing={processing}
            onChange={(changed: ModelBase) => {
              const new_obj = new_object;
              new_obj.copy(changed);
              setNewObject(new_obj);
              // setChangeTime(common_util.get_time_number());
            }}
            onCancel={() => { setOpen(false); }}
            onSubmit={submitNewObject}
          />
        </ModalOrDrawer>
      );
    }
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 4
        }}>
        <SelectStringBox 
          options={CHARACTER_LEVELS}
          value={`${obj.level}`} 
          name="Level"
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.level = +changed;
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <AddButton
              label="Add New"
              disabled={disabled}
              onClick={() => {
                const newbie = api.working_on_sb === null ? new Gift() : new Gift({ source_books: [{ id: api.working_on_sb._id, type: api.working_on_sb.source_book_type, third_party: api.working_on_sb.third_party }] });
                if (add_new_data) {
                  newbie.name = add_new_data.name ? add_new_data.name : "New Gift";
                  newbie.description = add_new_data.description ? add_new_data.description : "New Gift";
                } else {
                  newbie.name = "New Gift";
                  newbie.description = "New Gift";
                }
                if (api.user && api.user.admin) {
                  api.applyWorkingOn(newbie);
                }
                setNewObject(newbie);
                setOpen(true);
              }}
            />
            { renderExtras() }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            { !reloading &&
              <SelectObjectIndex
                data_type="gift"
                values={obj.conditions_applied}
                disableObj={() => {
                  return { disabled, reasons: "" };
                }}
                extra_filter={(o: ModelBase) => {
                  if (use_selected !== undefined) {
                    return obj.conditions_applied.includes(o._id) === use_selected;
                  } 
                  return true;
                }}
                filter={filter}
                updateFilter={updateFilter}
                extra_fields={["selected"]}
                quick_fields={["gift_type","selected"]}
                onChange={(changed: string[]) => {
                  const new_obj = obj;
                  new_obj.conditions_applied = changed;
                  onChange(new_obj);
                }}
              />
            }
          </Grid>
        </Grid>
      </Grid>
      <Grid
        size={{
          xs: 2
        }}>
        { !disabled &&
          <Tooltip title={`Delete Potence`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
    </Grid>
  );
}
